<template>
  <div class="local-phone-required-panel">
    <div class="background" @click="close" />
    <div class="wrapper">
      <!-- <p>Please provide a local contact method.</p> -->
      <p>Your account has an international phone:</p>
      <p class="has-text-weight-bold has-text-centered" style="padding: 12px">
        {{ $store.getters.phoneNumber }}
      </p>
      <p>A local contact method is required to make an order.</p>
      <p>
        Please provide a local contact number or indicate your preferred
        messaging app:
      </p>
      <br />
      <!-- <div style="background-color: white"> -->
      <p class="control">
        <input class="input is-fullwidth is-medium" v-model="phoneNumber" @keyup="messagingApp = null" type="number"
          placeholder="📞 0123456789" />
      </p>
      <p class="has-text-centered" style="margin-top: 8px">- OR -</p>
      <!-- <div class="is-divider" data-content="OR"></div> -->
      <p class="buttons" style="margin: 10px 0">
        <span v-for="a in apps" :key="a" class="button is-capitalized" :class="{ 'is-link': messagingApp === a }"
          @click="setMessagingApp(a)"><i :class="appIcon(a)" />&nbsp;{{ a }}</span>
      </p>
      <p class="button is-fullwidth is-success is-medium" :disabled="!validContact" @click="submit">
        Submit Order
      </p>
      <!-- </div> -->
    </div>
  </div>
</template>


<script>
export default {
  name: "LocalPhoneRequiredPanel",
  data() {
    return {
      messagingApp: null,
      phoneNumber: null,
      apps: ["whatsapp", "telegram", "line"],
    };
  },
  computed: {
    validContact() {
      if (this.messagingApp) return true;
      if (this.phoneNumber) {
        // starts with +66, 66 or 0
        return this.phoneNumber.length >= 10 && this.phoneNumber.length <= 12;
      }
      return false;
    },
  },
  mounted() { },
  methods: {
    submit() {
      var localContact = this.messagingApp;
      if (this.phoneNumber) localContact = this.phoneNumber;
      this.$emit("submit", localContact);
    },
    close() {
      this.$emit("close");
    },
    setMessagingApp(app) {
      this.phoneNumber = null;
      this.messagingApp = app;
    },
    appIcon(a) {
      return `fab fa-${a}`;
    },
  },
};
</script>

<style scoped>
.background {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1px);
}

.wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 20px;
  width: 100vw;
  max-width: 700px;
  /* padding-bottom: 40px; */
  /* border: 6px solid yellow; */
  background-color: rgb(255, 255, 100);
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }

  100% {
    box-shadow: 0 0 0 20px rgba(247, 211, 8, 0);
  }
}

.button {
  padding: 8px;
}
</style>